<template>
  <div >
    <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">学生个人管理</el-breadcrumb-item>
  <el-breadcrumb-item>学习汇报</el-breadcrumb-item>
  <el-breadcrumb-item>汇报列表</el-breadcrumb-item>
</el-breadcrumb>
    </div>
 
<el-card>
 <el-row>
  <!-- <el-col :span="20"><div class="grid-content bg-purple-dark"><el-input v-model="input" placeholder="请输入标题" ></el-input></div></el-col>
    <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary">查询</el-button></div></el-col> -->
  <el-col :span="2"><div class="grid-content bg-purple-light"> <el-button type="primary" @click="insertWork">添加</el-button></div></el-col>
</el-row>

 <el-table
    ref="multipleTable"
    :data="Worklist"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="handleSelectionChange"
    >
    
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
   
    <el-table-column
      label="汇报标题"
      width="120"
      :show-overflow-tooltip="true"
      prop="work_TITLE">
      
    </el-table-column>
    
    <el-table-column
      prop="work_CONTENT"
      label="今日完成"
      :show-overflow-tooltip="true"
      width="200">
    </el-table-column>
     <el-table-column
      prop="problem"
      :show-overflow-tooltip="true"
      label="存在问题"
      width="200">
    </el-table-column>
     <el-table-column
      prop="proposal"
      :show-overflow-tooltip="true"
      label="其他建议"
      width="200">
    </el-table-column>
     <el-table-column
      prop="createDate"
      label="汇报时间"
      width="180">
    </el-table-column>



 <el-table-column
      label="操作"
      width="240">

        <template slot-scope="scope" >
<el-button disabled  @click="updateNew(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
<el-button  @click="deleteworks(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<el-button   @click="showsWork(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
      </template>
    </el-table-column>

  </el-table>
  <div style="margin-top: 20px">
    <el-button @click="deleteSelection()">批量删除</el-button>
    <el-button @click="toggleSelection()">取消选择</el-button>
    <el-button  @click="selectTeacher()">选择老师</el-button>
  </div>

</el-card>

<el-dialog
  title="工作汇报"
  :visible.sync="dialogVisible"
  width="50%"
 >
  <!-- 添加工作 -->
  <el-form :model="ruleForm" :rules="rules" ref="ruleForms" label-width="100px" class="demo-ruleForm">
  <el-form-item label="汇报标题" prop="WORK_TITLE">
    <el-input v-model="ruleForm.WORK_TITLE"></el-input>
  </el-form-item>
  <el-form-item label="完成工作" prop="WORK_CONTENT">
    <el-input type="textarea" v-model="ruleForm.WORK_CONTENT"></el-input>
  </el-form-item>
  <el-form-item label="存在问题" prop="problem">
    <el-input type="textarea" v-model="ruleForm.problem"></el-input>
  </el-form-item><el-form-item label="其他建议" prop="proposal">
    <el-input type="textarea" v-model="ruleForm.proposal"></el-input>
  </el-form-item>
  <el-form-item label="是否已完成" prop="WORK_COMPLETE" v-show="false" >
   <el-radio-group v-model="ruleForm.WORK_COMPLETE" size="medium">
      <el-radio border label="0">进行中</el-radio>
      <el-radio border label="1">已完成</el-radio>
    </el-radio-group>
    </el-form-item>
    <el-form-item label="时间" prop="value1" v-show="false">
    <el-date-picker
      v-model="ruleForm.value1"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>

  <el-form-item label="汇报时间">
     
    <el-date-picker
      v-model="ruleForm.createDate"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
       :picker-options="pickerOptions"
      value-format="yyyy-MM-dd HH:mm:ss"
      default-time	
      >
    </el-date-picker>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForms')">立即创建</el-button>
    <el-button type="primary" @click="catInsert=true">预览</el-button>
    <el-button @click="resetForm('ruleForms')">重置</el-button>
  </el-form-item>
</el-form>
</el-dialog>
     <el-dialog
      width="80%"
     
      :visible.sync="catInsert"
      append-to-body>
      <InsertWorkModel  :WORK_CONTENT="ruleForm.WORK_CONTENT"  :title="ruleForm.WORK_TITLE" :problem="ruleForm.problem" :createDate="ruleForm.createDate" :proposal="ruleForm.proposal"></InsertWorkModel>
    </el-dialog>

      <el-dialog
      width="80%"
      
      :visible.sync="catwork"
      append-to-body>
      <InsertWorkModel  :WORK_CONTENT="workshowlist.work_CONTENT"  :title="workshowlist.work_TITLE" :problem="workshowlist.problem" :proposal="workshowlist.proposal" :createDate="workshowlist.createDate" ></InsertWorkModel>
    </el-dialog>

<el-dialog
  title="选择导师"
  :visible.sync="showVisible"
  width="50%"
 >
   <el-select v-model="teacher" placeholder="请选择">
    <el-option
      v-for="item in teacherList"
      :key="item.userid"
      :label=item.name
      :value="item.userid"
      >
    </el-option>
  </el-select>
  <span slot="footer" class="dialog-footer">
     
    <el-button @click="showVisible = false">取 消</el-button>
    <el-button type="primary" @click="onSubselectTer">提交</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import InsertWorkModel from '@/components/work/student/InsertWorkModel.vue'
export default {
  components:{  
    InsertWorkModel,
},
  created(){
    this.getwork()
    

  },
   
data(){
    return{
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        multipleSelection: [],
        tableData:[],
        Worklist:[],
        workshowlist:{},
        input:'',
        catwork:false,
        catInsert:false,
        teacherList:[],
        teacher:'',
        showVisible:false,
        dialogVisible: false,
        ruleForm:{
        WORK_TITLE:'',
        WORK_CONTENT:'',
        WORK_COMPLETE:'1',
        proposal:'',
        problem:'',
        userid:'',
        createDate:'',
         value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        work_BEGIN_TIME:'',
        work_END_TIME:'',        },
        rules:{
             WORK_TITLE: [
            { required: true, message: '汇报标题', trigger: 'blur' },
            { min: 3, max: 50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
            WORK_CONTENT: [
            { required: true, message: '汇报内容', trigger: 'blur' },
            { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
          ],
              WORK_COMPLETE: [
            { required: true, message: '请选择汇报进度', trigger: 'blur' },
    
          ],
          value1:[
              { required: true, message: '汇报内容', trigger: 'blur' }
          ]
    
        }
           
        
    }
},
 props:['user'],
methods:{
   getwork(){ 
    this.ruleForm.createDate =this.format(new Date(),'yyyy-MM-dd HH:mm:ss')
    this.ruleForm.userid=JSON.parse(localStorage.getItem('user')).userid
    console.log(this)
    
             this.axios.post("/work/getWork",'userid='+this.ruleForm.userid)
             .then(resp=>{
              if(resp.data.status==1){
                console.log(resp.data.result)
               resp.data.result.work_END_TIME= this.format( resp.data.result.work_END_TIME,'yyyy-MM-dd HH:mm:ss')
              this.Worklist=resp.data.result
              }
             })

      this.axios.post("/user/getUser",'type=0')
             .then(res=>{
              if(res.data.status==1){
                console.log(res.data.result)
               this.teacherList=res.data.result
              
              }
             })


  },
    showsWork(date){
      this.catwork=true
      this.axios.post("/work/getWorkByWorkid","wordid="+date.work_ID)
     .then(resp=>{
      if(resp.data.status===1){
        this.workshowlist=resp.data.result[0]
        console.log(resp.data.result)
      }
     })
    },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        insertWork(){
            this.dialogVisible = true
        
    },deleteworks(date){
      console.log(date)
      this.axios.post("/work/deleteworks","userid="+date.userid+"&work_ID="+date.work_ID)
      .then(resp=>{
        if(resp.data.status==1){
        this.$message.success("删除成功")
        this.getwork()
        }
        
      })
    },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      deleteSelection(){
          let config = {
        headers: { "Content-Type": "application/json" }
      };    
        console.log(this.multipleSelection)
        if(this.multipleSelection.length===0)
        retun 
       this.axios.post("/work/deleteMoreWorks",this.multipleSelection,config)
       .then(resp=>{
        console.log(resp.data)
        if(resp.data.status==1){
        this.$message.success("删除成功")
        this.getwork()
        }else{
          this.$message.error(resp.data.message)
        }
       })
      },selectTeacher(){
       this.showVisible=true;
      },
      onSubselectTer(){
         this.axios.post("/user/updateUserTeacherID",'userid='+this.ruleForm.userid+"&teacherid="+this.teacher)
         .then(resp=>{
          if(resp.data.status==1){
            this.$message.success("选择成功")
            this.showVisible=false
          }else{
             this.$message.error("失败")
          }
         })
      //this.showVisible=false
      },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
             let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };    
        
        this.ruleForm.work_BEGIN_TIME=this.format(this.ruleForm.value1[0],'yyyy-MM-dd HH:mm:ss')
        
       
        this.ruleForm.work_END_TIME=this.format(this.ruleForm.value1[1],'yyyy-MM-dd HH:mm:ss')
        this.ruleForm.userid=JSON.parse(localStorage.getItem('user')).userid
             this.axios.post("/work/insertWork",this.ruleForm,config)
             .then(resp=>{
              if( resp.data.status==1){
                this.$message(
                  {message:'添加成功',
                  type:'success'}
                )
                 this.$refs[formName].resetFields();
                this.getwork()
                this.dialogVisible=false
              }
             
             })
          } else {
            console.log('error submit!!');
            return false;
          }

          
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
       format(time, format) {
                var t = new Date(time);
                var tf = function (i) { return (i < 10 ? '0' : '') + i };
                return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
                    switch (a) {
                        case 'yyyy':
                            return tf(t.getFullYear());
                            break;
                        case 'MM':
                            return tf(t.getMonth() + 1);
                            break;
                        case 'mm':
                            return tf(t.getMinutes());
                            break;
                        case 'dd':
                            return tf(t.getDate());
                            break;
                        case 'HH':
                            return tf(t.getHours());
                            break;
                        case 'ss':
                            return tf(t.getSeconds());
                            break;
                    }
                })
            }

    },

}

</script>

<style>
.report_content{
    width: 100%;
    height: 100%;
    background-color: red;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/work/student/Report.vue